import { ApplierOption } from '../../../lib/helpers/ApplierOption';
import { TFunction } from 'i18next';

export function GetBulkActionDescription(t: TFunction<string, undefined>, type: ApplierOption | string): string {
  const translateText = (text: string, translationKey: string) => {
    const defaultKey = `BULK_ACTION_DESCRIPTION_${translationKey}`;
    return t(defaultKey, { defaultValue: text });
  };

  // Need a list of actions based on the selected TODO Like the SummaryGenerator and FilterApplier
  // SmartSendBulkActionOptions
  switch (type) {
    case 'RecipientContactDetails:Add':
      return translateText('Add missing contact details', 'ADD_DETAILS');

    case 'Service:Add':
      return translateText('Choose services for your orders', 'ADD_SERVICE');

    case 'Dimensions:Add':
      return translateText('Add missing dimensions', 'ADD_DIMENSIONS');

    case 'TariffCodes:Add':
      return translateText('Add missing Tariff Code', 'ADD_TARIFF_CODE');

    default:
      return 'Prepare and send your orders';
  }
}
